export default {
  title: 'Point activity by lifecycle stage',
  page_title: 'Point activity by lifecycle stage - Points | Thanx',
}
